<template>
    <b-modal id="disabling-datavant-tokenizaton-modal" ref="disablingDatavantTokenizationModal"  hide-header-close hide-footer :no-close-on-esc="noCloseOnBackdrop" :no-close-on-backdrop="noCloseOnBackdrop">
        <template slot="modal-title"></template>
        <span class="cross-icon" @click="cancel()">&times;</span>
        <div class="heading">
            <span class="title">Disabling Tokenization may reset token-</span><br />
            <span class="subtitle1"> linked fields back to its default values</span><br />
            <p>Would you like to continue?</p>
        </div>
        <div class="modal-button-container">
            <button class="button-cancel" @click="cancel">Cancel</button>
            <button class="button-confirm" @click="disableDatavantTokenization">Disable Tokenization</button>
        </div>
    </b-modal>
</template>
<script>

export default {
    name: "enabling-datavant-tokenization-modal",
    data() {
        return {
            noCloseOnBackdrop: true,
        };
    },
    props: ["isDatavantTokenizationEnabled"],
    methods: {
        show() {
            this.$refs.disablingDatavantTokenizationModal.show();
        },
        disableDatavantTokenization() {
            this.$emit("disable-datavant-tokenization", false);
            this.$refs.disablingDatavantTokenizationModal.hide();
        },
        cancel() {
            this.$emit("cancel-event", true);
            this.$refs.disablingDatavantTokenizationModal.hide();
        },
    }
};
</script>
<style lang="scss">
#disabling-datavant-tokenizaton-modal {
    @media (min-width: 469px) {
        .modal-dialog {
            width: 469px;
            height: 236px;
            vertical-align: middle;
        }
        .cross-icon {
            float: right;
            font-size: 31px;
            font-weight: 500;
            cursor: pointer;
            margin-top: -28px;
            margin-right: 5px;
            color: #666669;
        }

        .modal-header {
            border-bottom: none !important;
        }

        .modal-body {
            padding-top: 0px;
        }

        .heading {
            line-height: 1.3;
            margin-top: 16px;
        }

        span.title {
            font-size: 20px;
            color: #666669;
            font-family: Roboto-bold;
            margin-left: 29px;
        }

        span.subtitle1 {
            font-size: 20px;
            color: #666669;
            font-family: Roboto-bold;
            margin-left: 35px;
        }

        p {
            margin-top: 16px;
            margin-left: 128px;
        }

        .modal-button-container {
            display: flex;
            justify-content: center;
            align-items: center;
            margin-top: 20px;
            margin-bottom: 6px;
        }

        .button-cancel {
            color: #666669;
            margin: 0 10px;
            width: 146.9px;
            height: 41px;
            border: solid 1px #b0bac9;
            font-size: 16px;
            background-color: #fff !important;
            font-size: 14px !important;
            border-radius: 4px;
            font-family: Roboto-Medium;
            cursor: pointer;
            color: #4c8ce4;
        }

        .button-confirm {
            width: 155px;
            height: 41px;
            color: #fff;
            border: 1px solid #4c8ce4;
            background-color: #4c8ce4;
            cursor: pointer;
            font-size: 14px !important;
            color: #fff !important;
            border-radius: 4px;
            font-family: Roboto-Medium;
        }
    }
}
</style>
